(function () {
  'use strict';

  function initUpsell(container) {
    var firstVariantId  = container.dataset.firstVariantId;
    var upsellVariantId = container.dataset.upsellVariantId;
    var sectionId       = container.dataset.sectionId;

    var checkbox    = container.querySelector('.upsell-ki-trainer__checkbox');
    var hint        = container.querySelector('.upsell-ki-trainer__hint');
    var productInfo = document.getElementById('MainProduct-' + sectionId);
    var form        = document.getElementById('product-form-' + sectionId);
    var dynCheckout = document.querySelector(
      '#shopify-section-' + sectionId + ' .shopify-payment-button'
    );

    if (!form || !firstVariantId || !upsellVariantId || !checkbox) return;

    function getSelectedVariantId() {
      var input = form.querySelector('input.product-variant-id');
      return input ? input.value : null;
    }

    function isFirstVariantSelected() {
      return getSelectedVariantId() == firstVariantId;
    }

    function syncDynamicCheckout() {
      if (!dynCheckout) return;
      var hide = checkbox.checked;
      dynCheckout.style.opacity       = hide ? '0.3' : '';
      dynCheckout.style.pointerEvents = hide ? 'none' : '';
      hint.style.display              = hide ? 'block' : 'none';
    }

    function syncUpsellVisibility() {
      var show = isFirstVariantSelected();
      container.style.display = show ? 'block' : 'none';
      container.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (!show) {
        checkbox.checked = false;
        syncDynamicCheckout();
      }
    }

    // Varianten-Wechsel: change-Events vom Variant-Picker bubblen durch product-info hoch
    if (productInfo) {
      productInfo.addEventListener('change', syncUpsellVisibility);
    }

    // Checkbox-Wechsel: Dynamic Checkout Buttons ein-/ausblenden
    checkbox.addEventListener('change', syncDynamicCheckout);

    function getRoutesRoot() {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : '/';

      return root.endsWith('/') ? root : root + '/';
    }

    function getUpsellCheckoutUrl() {
      return getRoutesRoot() + 'cart/' + firstVariantId + ':1,' + upsellVariantId + ':1?checkout';
    }

    function goToUpsellCheckout(e) {
      if (!checkbox.checked || !isFirstVariantSelected()) return false;

      if (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }

      var submitBtn = form.querySelector('.product-form__submit');
      if (submitBtn) submitBtn.disabled = true;

      window.location.href = getUpsellCheckoutUrl();
      return true;
    }

    // Fängt den normalen Formular-Kaufbutton ab
    form.addEventListener('submit', function (e) {
      goToUpsellCheckout(e);
    }, true);

    // Fängt direkte Checkout-Buttons ab, z. B. Wi-ATC / Wizz Add To Cart
    document.addEventListener('click', function (e) {
      var checkoutLink = e.target.closest(
        'a[href*="/cart/"][href*="checkout"], .wbtn-wrapper[data-direction="checkout"], [id^="wbtn-wrapper-"][data-direction="checkout"]'
      );

      if (!checkoutLink) return;

      var section = document.getElementById('shopify-section-' + sectionId);
      if (section && !section.contains(checkoutLink)) return;

      goToUpsellCheckout(e);
    }, true);

    // Initiale Sichtbarkeit setzen
    syncUpsellVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.upsell-ki-trainer').forEach(initUpsell);
    });
  } else {
    document.querySelectorAll('.upsell-ki-trainer').forEach(initUpsell);
  }
})();